<template>
  <div id="app">
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
fnResize();
window.onresize = function() {
  fnResize();
};
function fnResize() {
  let viewWidth =
    document.documentElement.clientWidth || window.innerWidth;
  let size = 16 / 375;
  document.documentElement.style.fontSize = viewWidth * size + "px";
}
export default {
  name: 'App',
  components: {
    
  }
}
</script>

<style lang="scss">
  @import 'assets/sass/public/common.scss';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.van-toast{
  width:40%!important;
  // min-height: 20%!important;
}
.van-image-preview__close-icon--top-right{
  top:10px!important;
  right:10px!important;
}
</style>
